import { useEffect } from 'react';
import { Routes, Route, Outlet, Navigate } from "react-router-dom";

/*THEME*/
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './tema';
import './scss/general.scss';

/***REDUX****/
import { Provider } from 'react-redux';
import { loadUserClient } from './actions/auth';
import { loadAdmin } from './actions/adminAuth';
import { getCategories } from './actions/categories';
import store from './store';

import Login from './containers/auth/Login'
import ForgotPass from './containers/auth/ForgotPass';
import SignUp from './containers/auth/SignUp';
import Step2 from './components/auth/Step2';
import Step3 from './components/auth/Step3';
import LastStep from './components/auth/LastStep';

import Home from './containers/home/Home';

import Privacidad from './components/layout/Privacidad';
import CondicionesUso from './components/layout/CondicionesUso';
import Cookies from './components/layout/Cookies';
import TerminosCondiciones from './components/layout/TerminosCondiciones';

import Perfil from './containers/user/Perfil';
import PublicProfile from './containers/user/PublicProfile';
import ClientProfile from './containers/user/ClientProfile';
import SearchResults from './containers/public/SearchResults';
import PublicServiceDetail from './containers/public/PublicServiceDetail';
import Servicios from './containers/user/services/Servicios';
import PublicPageDetail from './containers/public/PublicPageDetail';
import BookingContainer from './containers/public/BookingContainer';
import Ayuda from './containers/public/Ayuda';
import NoEncontrado from './containers/public/NoEncontrado';

//necesarios
import setAuthToken from './utils/setAuthToken';
import PrivateRoute from './components/common/PrivateRoute';
import Layout from './components/layout/Layout';
import GeneralRoute from './components/common/GeneralRoute';
import LayoutSteps from './components/common/LayoutSteps';
import CrearServicio from './containers/user/services/CrearServicio';
import ServiceDetail from './containers/user/services/ServiceDetail';
import Favorites from './containers/user/Favorites';
import ScrollToTop from './components/common/ScrollToTop';
import PageTitle from './components/common/PageTitle';
import UserPageDetail from './containers/user/services/UserPageDetail';
import ChatPage from './components/chat/ChatPage';
import SoporteChat from './containers/support/SoporteChat';
import { SocketProvider } from './context/SocketContext';
import ChatFloating from './components/chat/ChatFloating';
import ProviderBookings from './containers/user/services/ProviderBookings';
import NotificacionesPage from './containers/user/NotificacionesPage';
import Colaboraciones from './containers/user/Colaboraciones';
import MisTickets from './containers/user/MisTickets';

//ADMIN
import AdminRoute from './components/admin/AdminRoute';
import AdminLayout from './components/admin/AdminLayout';
import AdminLogin from './containers/admin/AdminLogin';
import AdminDashboard from './containers/admin/AdminDashboard';
import Verificaciones from './containers/admin/Verificaciones';
import Directorio from './containers/admin/Directorio';
import Personas from './containers/admin/Personas';
import Catalogo from './containers/admin/Catalogo';
import Finanzas from './containers/admin/Finanzas';
import Tickets from './containers/admin/Tickets';
import SoporteAdmin from './containers/admin/SoporteAdmin';
import Promociones from './containers/admin/Promociones';
import Facturacion from './containers/admin/Facturacion';
import AdminPlaceholder from './components/admin/AdminPlaceholder';

if (localStorage.token) {
  setAuthToken(localStorage.token);
}

const App = () => {
  useEffect(() => {
    store.dispatch(loadUserClient());
    store.dispatch(loadAdmin());
    store.dispatch(getCategories());
  }, []);

  return (
    <Provider store={store}>
      <SocketProvider>
        <ThemeProvider theme={theme}>
          <ScrollToTop />
          <PageTitle />
          <Routes>
            { /**PANEL ADMIN**/}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route element={<AdminRoute />}>
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="verificacion" element={<Verificaciones />} />
                <Route path="negocios" element={<Directorio />} />
                <Route path="paginas" element={<Directorio />} />
                <Route path="servicios" element={<Directorio />} />
                <Route path="personas" element={<Personas />} />
                <Route path="categorias" element={<Catalogo />} />
                <Route path="tickets" element={<Tickets />} />
                <Route path="soporte" element={<SoporteAdmin />} />
                <Route path="finanzas" element={<Finanzas />} />
                <Route path="promociones" element={<Promociones />} />
                <Route path="facturacion" element={<Facturacion />} />
                <Route path="configuracion" element={<AdminPlaceholder titulo="Configuración Global" />} />
              </Route>
            </Route>

            { /**LOGUEO 2025**/}
            <Route element={<GeneralRoute />}>
              <Route path="login" element={<Login />} />
              <Route path="signup" element={<SignUp />} />
            </Route>

            { /**PASOS REGISTRO**/}
            <Route element={<LayoutSteps />} >
              <Route path="signup-step2" element={<Step2 />} />
              <Route path="signup-step3" element={<Step3 />} />
              <Route path="signup-last" element={<LastStep />} />
              <Route path="forgot-pass" element={<ForgotPass />} />
            </Route>

            {/* El inicio antes vivía en /home: los enlaces viejos, correos y marcadores siguen llegando */}
            <Route path="home" element={<Navigate to="/" replace />} />

            { /**RUTAS CON LAYOUT COMUN**/}
            <Route element={<Layout><Outlet /></Layout>}>
              <Route index element={<Home />} />
              <Route path="buscar" element={<SearchResults />} />
              <Route path="privacidad" element={<Privacidad />} />
              <Route path="condiciones-uso" element={<CondicionesUso />} />
              <Route path="cookies" element={<Cookies />} />
              <Route path="terminos-condiciones" element={<TerminosCondiciones />} />
              <Route path="ayuda" element={<Ayuda />} />
              <Route path="perfil/:idUsuario" element={<PublicProfile />} />
              <Route path="pagina/:pageId" element={<PublicPageDetail />} />
              <Route path="servicio/:userId/:serviceId" element={<PublicServiceDetail />} />

              {/* Ruta de Mensajes Protegida */}
              <Route element={<PrivateRoute />}>
                <Route path="servicio/:userId/:serviceId/reservar" element={<BookingContainer />} />
                <Route path="mensajes" element={<ChatPage />} />
                <Route path="soporte" element={<SoporteChat />} />
                <Route path="mi-perfil" element={<Perfil />} />
                <Route path="user/servicios" element={<Servicios />} />
                <Route path="user/crear-servicio/:tab" element={<CrearServicio />} />
                <Route path="user/servicio/:id" element={<ServiceDetail />} />
                <Route path="user/pagina/:pageId" element={<UserPageDetail />} />
                <Route path="user/favoritos/:id" element={<Favorites />} />
                <Route path="user/reservas-proveedor" element={<ProviderBookings />} />
                <Route path="user/cliente/:idCliente" element={<ClientProfile />} />
                <Route path="user/notificaciones" element={<NotificacionesPage />} />
                <Route path="user/colaboraciones" element={<Colaboraciones />} />
                <Route path="user/tickets" element={<MisTickets />} />
              </Route>

              {/* Cualquier otra dirección: «No encontramos esta página», con el encabezado y el pie de siempre */}
              <Route path="*" element={<NoEncontrado />} />
            </Route>
          </Routes>
          <ChatFloating />
        </ThemeProvider>
      </SocketProvider>
    </Provider>
  )
};

export default App;
